import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '../store/auth.store';
import { apiFetch } from '../lib/api';

export interface MeResult {
  id: string;
  name: string | null;
  role: 'user' | 'admin';
  netsuiteRoleName: string | null;
  hostAccountId: string | null;
}

export function useMe() {
  const accessToken = useAuthStore((s) => s.accessToken);

  return useQuery({
    queryKey: ['me'],
    queryFn: async () => {
      const res = await apiFetch('/api/chat/me');
      if (!res.ok) throw new Error('Failed to load profile');
      const data = await res.json();
      return data.user as MeResult;
    },
    enabled: !!accessToken,
    staleTime: 5 * 60_000,
  });
}
